import React from 'react';
import styled from 'styled-components';

const Search = styled.div`
 display: ${props => props.mobileOnly ? "none" :"flex"};
 line-height: 28px;
 align-items: center;
 position: relative;
 width:${props => props.width};
 margin:${props => props.margin};
 @media(max-width:700px)
 {
     width:${props => props.widthBefore700}
 }
 @media(max-width:${props => props.visibleAt})
 {
    display:flex;
 }
`

const Input = styled.input`
 width: 100%;
 height: 40px;
 line-height: 28px;
 padding:${props => props.padding};
 padding-left: 2.5rem;
 border: 2px solid transparent;
 border-radius: 8px;
 outline: none;
 color: #0d0c22;
 transition: .3s ease;
 &::placeholder
 {
     color:rgba(0,0,0,0.5);
 }
 &:hover
 {
 outline: none;
 border-color: rgba(0,0,0,0.5);
 background-color: #fff;
 box-shadow: 0 0 0 4px rgb(0,0,0 / 10%);
 }
 &:focus 
 {
 outline: none;
 border-color: rgba(0,0,0,0.5);
 background-color: #fff;
 box-shadow: 0 0 0 4px rgb(0,0,0 / 10%);
 }
`

const Icon = styled.svg`
 position: absolute;
 fill:#000;
 left: 1rem;
 width: 1rem;
 height: 1rem;
`;

Search.defaultProps = {
    width:"100%",
    padding:"0 1rem"
}

const SearchBar = (props) => {
  return (
  <Search {...props} > 
  <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"> <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/> </Icon>
  <Input {...props} />
</Search>
  )
}

export default SearchBar;
